/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Text_To_Title_CaseInputs */

const en_text_to_title_case = /** @type {(inputs: Text_To_Title_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text to Title Case`)
};

const fr_text_to_title_case = /** @type {(inputs: Text_To_Title_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte en casse de titre`)
};

const de_text_to_title_case = /** @type {(inputs: Text_To_Title_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text in Titelformatierung`)
};

const it_text_to_title_case = /** @type {(inputs: Text_To_Title_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo in maiuscolo/minuscolo`)
};

const ru_text_to_title_case = /** @type {(inputs: Text_To_Title_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текст с регистром заголовка`)
};

const es_text_to_title_case = /** @type {(inputs: Text_To_Title_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto a título en mayúsculas y minúsculas`)
};

const zh_cn2_text_to_title_case = /** @type {(inputs: Text_To_Title_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本转换为标题大小写`)
};

const ja_text_to_title_case = /** @type {(inputs: Text_To_Title_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストをタイトル大文字にする`)
};

const hi_text_to_title_case = /** @type {(inputs: Text_To_Title_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट को टाइटल केस में बदलें`)
};

const pt_pt2_text_to_title_case = /** @type {(inputs: Text_To_Title_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto para título em caixa alta/baixa`)
};

/**
* | output |
* | --- |
* | "Text to Title Case" |
*
* @param {Text_To_Title_CaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const text_to_title_case = /** @type {((inputs?: Text_To_Title_CaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Text_To_Title_CaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_text_to_title_case(inputs)
	if (locale === "de") return de_text_to_title_case(inputs)
	if (locale === "it") return it_text_to_title_case(inputs)
	if (locale === "ru") return ru_text_to_title_case(inputs)
	if (locale === "es") return es_text_to_title_case(inputs)
	if (locale === "zh-CN") return zh_cn2_text_to_title_case(inputs)
	if (locale === "ja") return ja_text_to_title_case(inputs)
	if (locale === "hi") return hi_text_to_title_case(inputs)
	if (locale === "pt-PT") return pt_pt2_text_to_title_case(inputs)
	return en_text_to_title_case(inputs)
});